export const SET_PRICE_PRECENT = "SET_PRICE_PRECENT"
export const SET_RATE_PLAN = "SET_RATE_PLAN"
export const SET_SALES_ACTIVE = "SET_SALES_ACTIVE"
